const indexes = {
  issuers: process.env.FUNDAMENTEI_ENV === "production" ? "issuers" : "issuers_qa",
};

export default indexes;
